import React, { Dispatch, SetStateAction } from 'react';
import styles from './AvailabilityHeader.module.css';
import moment from 'moment';
import { Tab, TabList, Tabs } from 'react-tabs';
import { Data } from '../../interfaces/Availability.interface';

interface AvailabilityHeaderProps {
    data: Data;
    selectedDate: Date;
    activeTab: number;
    setActiveTab: Dispatch<SetStateAction<number>>;
    setSelectedSlots: Dispatch<SetStateAction<number[]>>;
    lockers: number;
    locationData: any;
}

const AvailabilityHeader = ({ data, selectedDate, activeTab, setActiveTab, setSelectedSlots, lockers, locationData }: AvailabilityHeaderProps) => {

    return (
        <div className={styles.slotsHeader}>
            <h2>
                Create availability for {data?.name} {data?.nickName || ''} starting on <span>{moment(selectedDate).format('YYYY-MM-DD')}</span>
            </h2>

            {locationData && locationData?.location?.lockerTypeLockerName?.toLowerCase() !== 'bms' && (
                <div className={`${styles.tabWrapper} tabWrapper`}>
                    <Tabs
                        selectedIndex={activeTab}
                        onSelect={(index) => {
                            setActiveTab(index);
                            setSelectedSlots([]);
                        }}>
                        <TabList>
                            {Array(lockers)
                                .fill('')
                                .map((locker, index) => (
                                    <Tab key={index}>Locker {index + 1}</Tab>
                                ))}
                        </TabList>
                    </Tabs>
                </div>
            )}

        </div>
    );
};

export default AvailabilityHeader;
